import { render, staticRenderFns } from "./SkuPackingStructureTree.vue?vue&type=template&id=bb436780&scoped=true"
import script from "./SkuPackingStructureTree.vue?vue&type=script&lang=js"
export * from "./SkuPackingStructureTree.vue?vue&type=script&lang=js"
import style0 from "./SkuPackingStructureTree.vue?vue&type=style&index=0&id=bb436780&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb436780",
  null
  
)

export default component.exports